(function () {
  const counter = document.getElementById('announcement-counter');
  if (!counter) return;

  const deadlineText = counter.getAttribute('data-offer-ends');
  if (!deadlineText) return;

  const [datePart, timePart] = deadlineText.split(' ');
  const [day, month, year] = datePart.split('-');
  const [hours, minutes, seconds] = timePart.split(':');
  const deadline = new Date(year, month - 1, day, hours, minutes, seconds);

  const fields = {
    days: counter.querySelector('.days'),
    hours: counter.querySelector('.hours'),
    min: counter.querySelector('.min'),
    sec: counter.querySelector('.sec'),
  };
  const banner = counter.closest('.block-counter__product-info');
  let interval = null;

  function stop() {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  }

  function updateCounter() {
    const difference = deadline - new Date();

    if (difference < 0) {
      stop();
      fields.days.textContent = '00';
      fields.hours.textContent = '00';
      fields.min.textContent = '00';
      fields.sec.textContent = '00';
      if (banner) banner.classList.add('hidden');
      return;
    }

    fields.days.textContent = Math.floor(difference / (1000 * 60 * 60 * 24))
      .toString()
      .padStart(2, '0');
    fields.hours.textContent = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      .toString()
      .padStart(2, '0');
    fields.min.textContent = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
      .toString()
      .padStart(2, '0');
    fields.sec.textContent = Math.floor((difference % (1000 * 60)) / 1000)
      .toString()
      .padStart(2, '0');
    if (banner) banner.classList.remove('hidden');
  }

  updateCounter();

  // Solo actualiza cada segundo mientras el contador está en pantalla
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (!interval) interval = setInterval(updateCounter, 1000);
      } else {
        stop();
      }
    });
  });
  observer.observe(counter);
})();
